module.exports = __webpack_public_path__ + "img/kr-product-title-img-5.794692a.png";